<template>
  <div>
    <yunyingList :xiugai_type="1" :show_type="1" ref="yunyingRef"  :key="datekey"> </yunyingList>
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import yunyingList from '../../tongyong/yunying.vue';
 
export default {

  components: {
    yunyingList: yunyingList 
  },

  data() {
    return {
      datekey: Date.now() 
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
